import PageHeader from '@/components/common/PageHeader';

const RefundPolicyPage = () => {
  return (
    <div data-testid="refund-policy-page">
      <PageHeader 
        title="Refund Policy"
        subtitle="Our commitment to fair and transparent refund practices"
        breadcrumbs={[{ label: 'Refund Policy' }]}
      />

      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto prose prose-lg">
            <p className="text-gray-600 mb-8">
              <strong>Last Updated: January 1, 2026</strong>
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">1. Service Fee Structure</h2>
            <p className="text-gray-600 mb-6">
              Zafco Human Resource Management charges service fees for various immigration and recruitment 
              services. Our fees are structured as follows:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Professional Service Fees (consultation, documentation, application preparation)</li>
              <li>Government Fees (visa fees, biometrics, medical - paid to authorities)</li>
              <li>Third-Party Fees (skills assessment, language tests, credential evaluation)</li>
            </ul>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">2. Refund Eligibility</h2>
            
            <h3 className="text-xl font-semibold text-zafco-blue mb-3">2.1 Full Refund</h3>
            <p className="text-gray-600 mb-4">A full refund of professional service fees may be provided if:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Services are cancelled within 48 hours of payment and no work has commenced</li>
              <li>Zafco fails to provide the agreed services</li>
              <li>Client is found ineligible during initial assessment (before case initiation)</li>
            </ul>

            <h3 className="text-xl font-semibold text-zafco-blue mb-3">2.2 Partial Refund</h3>
            <p className="text-gray-600 mb-4">Partial refunds may be considered based on:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Stage of case processing at time of cancellation</li>
              <li>Work completed and time invested</li>
              <li>Third-party fees already paid (non-recoverable)</li>
            </ul>

            <h3 className="text-xl font-semibold text-zafco-blue mb-3">2.3 No Refund Situations</h3>
            <p className="text-gray-600 mb-4">Refunds are not provided in the following cases:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Visa refusal due to client misrepresentation or false information</li>
              <li>Client's failure to provide required documents</li>
              <li>Changes in immigration policies affecting eligibility</li>
              <li>Government or third-party fees (as these are non-recoverable)</li>
              <li>Services substantially completed as per agreement</li>
              <li>Client withdrawal after case submission</li>
            </ul>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">3. Refund Process</h2>
            <p className="text-gray-600 mb-6">
              To request a refund, please contact us via WhatsApp at +91-9958848998 or email info@zafco.in 
              with your case reference number. Refund requests are processed within 15-30 business days 
              after approval.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">4. Visa Refusal Policy</h2>
            <p className="text-gray-600 mb-6">
              In case of visa refusal not caused by client negligence, we offer re-application assistance 
              at reduced fees or partial service credit for future applications, subject to individual 
              case assessment.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">5. Contact Us</h2>
            <p className="text-gray-600 mb-6">
              For refund queries or disputes, please contact:
            </p>
            <p className="text-gray-600 mb-6">
              <strong>Zafco Human Resource Management</strong><br />
              Ground Floor 5, Building No. 27B,<br />
              Khizrabad, New Friends Colony,<br />
              New Delhi - 110025<br />
              Phone: +91-9958848998<br />
              Email: info@zafco.in
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RefundPolicyPage;
